import chunkArray from 'lodash.chunk';
import type { TArrivalInformation } from 'api/swagger';
import { TripTaskType } from 'types/trips';

const CHUNK_SIZE = 4;

export const buildStepTitle = (info: TArrivalInformation) => {
  let title = TripTaskType[info.taskType];

  if (info.pointName) {
    title += ` - ${info.pointName}`;
  }

  return title;
};

export const prepareArrivalInformationChunks = (arrivalInformation: TArrivalInformation[]) => {
  return chunkArray<TArrivalInformation>(arrivalInformation, CHUNK_SIZE);
};
